import React, { useState, useEffect, DragEvent, useRef } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  IconButton,
  Paper,
  InputAdornment,
  Chip,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Breadcrumbs,
  Link,
  useMediaQuery,
  useTheme,
  Divider,
  Avatar,
  Card,
  CardContent,
  CardActions,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Skeleton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import {
  Add,
  Edit,
  Delete,
  Visibility,
  Search,
  FilterList,
  Clear,
  Home,
  NavigateNext,
  CloudUpload,
  FileDownload,
  ExpandMore,
  Business,
  Phone,
  Email,
  LocationOn,
  Language,
  ContactMail,
} from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/* -------------------- INTERFACES -------------------- */
interface CarteVisite {
  id?: number;
  fournisseurId?: number;
  contact: string;
  telephone: string;
  telephonePortable: string;
  poste: string;
  address: string;
  comment: string;
  email: string;
  website: string;
  imageFace: string;
  imageBack: string;
  imageFaceFile?: File | null;
  imageBackFile?: File | null;
}

interface Fournisseur {
  id: number;
  supplier: string;
  company: string;
  telephone: string;
  email: string;
  address: string;
  country: string;
  website: string;
  comment: string;
  cartesVisites?: CarteVisite[];
  createdAt?: string;
}

interface CountryData {
  name: string;
  code: string; // Code ISO 3166-1 alpha-2 (pour les drapeaux)
  phoneCode?: string; // Code téléphonique international (optionnel)
}

interface FournisseurForm {
  supplier: string;
  company: string;
  telephone: string;
  email: string;
  address: string;
  country: string;
  website: string;
  comment: string;
  cartesVisites: CarteVisite[];
}

interface CountryData {
  name: string;
  code: string;
  phoneCode?: string;
}

const countryList: CountryData[] = [
  { name: "Afghanistan", code: "AF", phoneCode: "+93" },
  { name: "Albania", code: "AL", phoneCode: "+355" },
  { name: "Algeria", code: "DZ", phoneCode: "+213" },
  { name: "Andorra", code: "AD", phoneCode: "+376" },
  { name: "Angola", code: "AO", phoneCode: "+244" },
  { name: "Antigua & Deps", code: "AG", phoneCode: "+1-268" },
  { name: "Argentina", code: "AR", phoneCode: "+54" },
  { name: "Armenia", code: "AM", phoneCode: "+374" },
  { name: "Australia", code: "AU", phoneCode: "+61" },
  { name: "Austria", code: "AT", phoneCode: "+43" },
  { name: "Azerbaijan", code: "AZ", phoneCode: "+994" },
  { name: "Bahamas", code: "BS", phoneCode: "+1-242" },
  { name: "Bahrain", code: "BH", phoneCode: "+973" },
  { name: "Bangladesh", code: "BD", phoneCode: "+880" },
  { name: "Barbados", code: "BB", phoneCode: "+1-246" },
  { name: "Belarus", code: "BY", phoneCode: "+375" },
  { name: "Belgium", code: "BE", phoneCode: "+32" },
  { name: "Belize", code: "BZ", phoneCode: "+501" },
  { name: "Benin", code: "BJ", phoneCode: "+229" },
  { name: "Bhutan", code: "BT", phoneCode: "+975" },
  { name: "Bolivia", code: "BO", phoneCode: "+591" },
  { name: "Bosnia Herzegovina", code: "BA", phoneCode: "+387" },
  { name: "Botswana", code: "BW", phoneCode: "+267" },
  { name: "Brazil", code: "BR", phoneCode: "+55" },
  { name: "Brunei", code: "BN", phoneCode: "+673" },
  { name: "Bulgaria", code: "BG", phoneCode: "+359" },
  { name: "Burkina", code: "BF", phoneCode: "+226" },
  { name: "Burundi", code: "BI", phoneCode: "+257" },
  { name: "Cambodia", code: "KH", phoneCode: "+855" },
  { name: "Cameroon", code: "CM", phoneCode: "+237" },
  { name: "Canada", code: "CA", phoneCode: "+1" },
  { name: "Cape Verde", code: "CV", phoneCode: "+238" },
  { name: "Central African Rep", code: "CF", phoneCode: "+236" },
  { name: "Chad", code: "TD", phoneCode: "+235" },
  { name: "Chile", code: "CL", phoneCode: "+56" },
  { name: "China", code: "CN", phoneCode: "+86" },
  { name: "Colombia", code: "CO", phoneCode: "+57" },
  { name: "Comoros", code: "KM", phoneCode: "+269" },
  { name: "Congo", code: "CG", phoneCode: "+242" },
  { name: "Congo {Democratic Rep}", code: "CD", phoneCode: "+243" },
  { name: "Costa Rica", code: "CR", phoneCode: "+506" },
  { name: "Croatia", code: "HR", phoneCode: "+385" },
  { name: "Cuba", code: "CU", phoneCode: "+53" },
  { name: "Cyprus", code: "CY", phoneCode: "+357" },
  { name: "Czech Republic", code: "CZ", phoneCode: "+420" },
  { name: "Denmark", code: "DK", phoneCode: "+45" },
  { name: "Djibouti", code: "DJ", phoneCode: "+253" },
  { name: "Dominica", code: "DM", phoneCode: "+1-767" },
  {
    name: "Dominican Republic",
    code: "DO",
    phoneCode: "+1-809, +1-829, +1-849",
  },
  { name: "East Timor", code: "TL", phoneCode: "+670" },
  { name: "Ecuador", code: "EC", phoneCode: "+593" },
  { name: "Egypt", code: "EG", phoneCode: "+20" },
  { name: "El Salvador", code: "SV", phoneCode: "+505" },
  { name: "Equatorial Guinea", code: "GQ", phoneCode: "+240" },
  { name: "Eritrea", code: "ER", phoneCode: "+291" },
  { name: "Estonia", code: "EE", phoneCode: "+372" },
  { name: "Ethiopia", code: "ET", phoneCode: "+251" },
  { name: "Fiji", code: "FJ", phoneCode: "+679" },
  { name: "Finland", code: "FI", phoneCode: "+358" },
  { name: "France", code: "FR", phoneCode: "+33" },
  { name: "Gabon", code: "GA", phoneCode: "+241" },
  { name: "Gambia", code: "GM", phoneCode: "+220" },
  { name: "Georgia", code: "GE", phoneCode: "+995" },
  { name: "Germany", code: "DE", phoneCode: "+49" },
  { name: "Ghana", code: "GH", phoneCode: "+233" },
  { name: "Greece", code: "GR", phoneCode: "+30" },
  { name: "Grenada", code: "GD", phoneCode: "+1-473" },
  { name: "Guatemala", code: "GT", phoneCode: "+502" },
  { name: "Guinea", code: "GN", phoneCode: "+224" },
  { name: "Guinea-Bissau", code: "GW", phoneCode: "+245" },
  { name: "Guyana", code: "GY", phoneCode: "+592" },
  { name: "Haiti", code: "HT", phoneCode: "+509" },
  { name: "Honduras", code: "HN", phoneCode: "+504" },
  { name: "Hungary", code: "HU", phoneCode: "+36" },
  { name: "Iceland", code: "IS", phoneCode: "+354" },
  { name: "India", code: "IN", phoneCode: "+91" },
  { name: "Indonesia", code: "ID", phoneCode: "+62" },
  { name: "Iran", code: "IR", phoneCode: "+98" },
  { name: "Iraq", code: "IQ", phoneCode: "+964" },
  { name: "Ireland {Republic}", code: "IE", phoneCode: "+353" },
  { name: "Israel", code: "IL", phoneCode: "+972" },
  { name: "Italy", code: "IT", phoneCode: "+39" },
  { name: "Ivory Coast", code: "CI", phoneCode: "+225" },
  { name: "Jamaica", code: "JM", phoneCode: "+1-876" },
  { name: "Japan", code: "JP", phoneCode: "+81" },
  { name: "Jordan", code: "JO", phoneCode: "+962" },
  { name: "Kazakhstan", code: "KZ", phoneCode: "+7" },
  { name: "Kenya", code: "KE", phoneCode: "+254" },
  { name: "Kiribati", code: "KI", phoneCode: "+686" },
  { name: "Korea North", code: "KP", phoneCode: "+850" },
  { name: "Korea South", code: "KR", phoneCode: "+82" },
  { name: "Kosovo", code: "XK", phoneCode: "+383" },
  { name: "Kuwait", code: "KW", phoneCode: "+965" },
  { name: "Kyrgyzstan", code: "KG", phoneCode: "+996" },
  { name: "Laos", code: "LA", phoneCode: "+856" },
  { name: "Latvia", code: "LV", phoneCode: "+371" },
  { name: "Lebanon", code: "LB", phoneCode: "+961" },
  { name: "Lesotho", code: "LS", phoneCode: "+266" },
  { name: "Liberia", code: "LR", phoneCode: "+231" },
  { name: "Libya", code: "LY", phoneCode: "+218" },
  { name: "Liechtenstein", code: "LI", phoneCode: "+423" },
  { name: "Lithuania", code: "LT", phoneCode: "+370" },
  { name: "Luxembourg", code: "LU", phoneCode: "+352" },
  { name: "Macedonia", code: "MK", phoneCode: "+389" },
  { name: "Madagascar", code: "MG", phoneCode: "+261" },
  { name: "Malawi", code: "MW", phoneCode: "+265" },
  { name: "Malaysia", code: "MY", phoneCode: "+60" },
  { name: "Maldives", code: "MV", phoneCode: "+960" },
  { name: "Mali", code: "ML", phoneCode: "+223" },
  { name: "Malta", code: "MT", phoneCode: "+356" },
  { name: "Marshall Islands", code: "MH", phoneCode: "+692" },
  { name: "Mauritania", code: "MR", phoneCode: "+222" },
  { name: "Mauritius", code: "MU", phoneCode: "+230" },
  { name: "Mexico", code: "MX", phoneCode: "+52" },
  { name: "Micronesia", code: "FM", phoneCode: "+691" },
  { name: "Moldova", code: "MD", phoneCode: "+373" },
  { name: "Monaco", code: "MC", phoneCode: "+377" },
  { name: "Mongolia", code: "MN", phoneCode: "+976" },
  { name: "Montenegro", code: "ME", phoneCode: "+382" },
  { name: "Morocco", code: "MA", phoneCode: "+212" },
  { name: "Mozambique", code: "MZ", phoneCode: "+258" },
  { name: "Myanmar, {Burma}", code: "MM", phoneCode: "+95" },
  { name: "Namibia", code: "NA", phoneCode: "+264" },
  { name: "Nauru", code: "NR", phoneCode: "+674" },
  { name: "Nepal", code: "NP", phoneCode: "+977" },
  { name: "Netherlands", code: "NL", phoneCode: "+31" },
  { name: "New Zealand", code: "NZ", phoneCode: "+64" },
  { name: "Nicaragua", code: "NI", phoneCode: "+505" },
  { name: "Niger", code: "NE", phoneCode: "+227" },
  { name: "Nigeria", code: "NG", phoneCode: "+234" },
  { name: "Norway", code: "NO", phoneCode: "+47" },
  { name: "Oman", code: "OM", phoneCode: "+968" },
  { name: "Pakistan", code: "PK", phoneCode: "+92" },
  { name: "Palau", code: "PW", phoneCode: "+680" },
  { name: "Panama", code: "PA", phoneCode: "+507" },
  { name: "Papua New Guinea", code: "PG", phoneCode: "+675" },
  { name: "Paraguay", code: "PY", phoneCode: "+595" },
  { name: "Peru", code: "PE", phoneCode: "+51" },
  { name: "Philippines", code: "PH", phoneCode: "+63" },
  { name: "Poland", code: "PL", phoneCode: "+48" },
  { name: "Portugal", code: "PT", phoneCode: "+351" },
  { name: "Qatar", code: "QA", phoneCode: "+974" },
  { name: "Romania", code: "RO", phoneCode: "+40" },
  { name: "Russian Federation", code: "RU", phoneCode: "+7" },
  { name: "Rwanda", code: "RW", phoneCode: "+250" },
  { name: "St Kitts & Nevis", code: "KN", phoneCode: "+1-869" },
  { name: "St Lucia", code: "LC", phoneCode: "+1-758" },
  { name: "Saint Vincent & the Grenadines", code: "VC", phoneCode: "+1-784" },
  { name: "Samoa", code: "WS", phoneCode: "+685" },
  { name: "San Marino", code: "SM", phoneCode: "+378" },
  { name: "Sao Tome & Principe", code: "ST", phoneCode: "+239" },
  { name: "Saudi Arabia", code: "SA", phoneCode: "+966" },
  { name: "Senegal", code: "SN", phoneCode: "+221" },
  { name: "Serbia", code: "RS", phoneCode: "+381" },
  { name: "Seychelles", code: "SC", phoneCode: "+248" },
  { name: "Sierra Leone", code: "SL", phoneCode: "+232" },
  { name: "Singapore", code: "SG", phoneCode: "+65" },
  { name: "Slovakia", code: "SK", phoneCode: "+421" },
  { name: "Slovenia", code: "SI", phoneCode: "+386" },
  { name: "Solomon Islands", code: "SB", phoneCode: "+677" },
  { name: "Somalia", code: "SO", phoneCode: "+252" },
  { name: "South Africa", code: "ZA", phoneCode: "+27" },
  { name: "South Sudan", code: "SS", phoneCode: "+211" },
  { name: "Spain", code: "ES", phoneCode: "+34" },
  { name: "Sri Lanka", code: "LK", phoneCode: "+94" },
  { name: "Sudan", code: "SD", phoneCode: "+249" },
  { name: "Suriname", code: "SR", phoneCode: "+597" },
  { name: "Swaziland", code: "SZ", phoneCode: "+268" },
  { name: "Sweden", code: "SE", phoneCode: "+46" },
  { name: "Switzerland", code: "CH", phoneCode: "+41" },
  { name: "Syria", code: "SY", phoneCode: "+963" },
  { name: "Taiwan", code: "TW", phoneCode: "+886" },
  { name: "Tajikistan", code: "TJ", phoneCode: "+992" },
  { name: "Tanzania", code: "TZ", phoneCode: "+255" },
  { name: "Thailand", code: "TH", phoneCode: "+66" },
  { name: "Togo", code: "TG", phoneCode: "+228" },
  { name: "Tonga", code: "TO", phoneCode: "+676" },
  { name: "Trinidad & Tobago", code: "TT", phoneCode: "+1-868" },
  { name: "Tunisia", code: "TN", phoneCode: "+216" },
  { name: "Turkey", code: "TR", phoneCode: "+90" },
  { name: "Turkmenistan", code: "TM", phoneCode: "+993" },
  { name: "Tuvalu", code: "TV", phoneCode: "+688" },
  { name: "Uganda", code: "UG", phoneCode: "+256" },
  { name: "Ukraine", code: "UA", phoneCode: "+380" },
  { name: "United Arab Emirates", code: "AE", phoneCode: "+971" },
  { name: "United Kingdom", code: "GB", phoneCode: "+44" },
  { name: "United States", code: "US", phoneCode: "+1" },
  { name: "Uruguay", code: "UY", phoneCode: "+598" },
  { name: "Uzbekistan", code: "UZ", phoneCode: "+998" },
  { name: "Vanuatu", code: "VU", phoneCode: "+678" },
  { name: "Vatican City", code: "VA", phoneCode: "+379" },
  { name: "Venezuela", code: "VE", phoneCode: "+58" },
  { name: "Vietnam", code: "VN", phoneCode: "+84" },
  { name: "Yemen", code: "YE", phoneCode: "+967" },
  { name: "Zambia", code: "ZM", phoneCode: "+260" },
  { name: "Zimbabwe", code: "ZW", phoneCode: "+263" },
  // ... Ajoutez les autres pays selon vos besoins
];

const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_Image;

const emptyCarteVisite: CarteVisite = {
  contact: "",
  telephone: "",
  telephonePortable: "",
  poste: "",
  address: "",
  comment: "",
  email: "",
  website: "",
  imageFace: "",
  imageBack: "",
  imageFaceFile: null,
  imageBackFile: null,
};

/* -------------------- COMPONENT -------------------- */
const FournisseurPage: React.FC = () => {
  const [fournisseurs, setFournisseurs] = useState<Fournisseur[]>([]);
  const [modalType, setModalType] = useState<"add" | "edit" | "view" | null>(
    null,
  );
  const [form, setForm] = useState<FournisseurForm>({
    supplier: "",
    company: "",
    telephone: "",
    email: "",
    address: "",
    country: "",
    website: "",
    comment: "",
    cartesVisites: [],
  });
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [countryFilter, setCountryFilter] = useState<string>("all");
  const [viewMode, setViewMode] = useState<"table" | "grid">("table");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [fournisseurToDelete, setFournisseurToDelete] =
    useState<Fournisseur | null>(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);

  /* -------------------- API CALLS -------------------- */
  const fetchFournisseurs = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/fournisseurs`);
      console.log("Raw API response:", res.data);
      console.log("Number of fournisseurs:", res.data.length);
      const fournisseursWithCartes = await Promise.all(
        res.data.map(async (fournisseur: Fournisseur) => {
          try {
            const cartesRes = await axios.get(
              `${API_URL}/cartes-visites/fournisseur/${fournisseur.id}`,
            );
            return { ...fournisseur, cartesVisites: cartesRes.data };
          } catch (err) {
            console.error(
              `Error fetching cartes for fournisseur ${fournisseur.id}:`,
              err,
            );
            return { ...fournisseur, cartesVisites: [] };
          }
        }),
      );
      console.log(
        "Processed fournisseurs with cartes:",
        fournisseursWithCartes,
      );
      console.log(
        "Setting fournisseurs state with:",
        fournisseursWithCartes.length,
        "items",
      );
      setFournisseurs(fournisseursWithCartes);
    } catch (err) {
      console.error("Error fetching fournisseurs:", err);
      toast.error("Failed to load fournisseurs. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const createFournisseur = async () => {
    try {
      const res = await axios.post(`${API_URL}/fournisseurs`, {
        supplier: form.supplier,
        company: form.company,
        telephone: form.telephone,
        email: form.email,
        address: form.address,
        country: form.country,
        website: form.website,
        comment: form.comment,
      });

      // Create cartes visites for the new fournisseur
      if (form.cartesVisites.length > 0) {
        await Promise.all(
          form.cartesVisites.map(async (carte) => {
            const formData = new FormData();
            formData.append("fournisseurId", res.data.id.toString());
            formData.append("contact", carte.contact);
            formData.append("telephone", carte.telephone);
            formData.append("telephonePortable", carte.telephonePortable);
            formData.append("poste", carte.poste);
            formData.append("address", carte.address);
            formData.append("comment", carte.comment);
            formData.append("email", carte.email);
            formData.append("website", carte.website);
            if (carte.imageFaceFile)
              formData.append("imageFace", carte.imageFaceFile);
            if (carte.imageBackFile)
              formData.append("imageBack", carte.imageBackFile);

            await axios.post(`${API_URL}/cartes-visites`, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
          }),
        );
      }

      toast.success("Fournisseur created successfully! 🎉");
      fetchFournisseurs();
    } catch (err) {
      console.error("Error creating fournisseur:", err);
      toast.error("Failed to create fournisseur.");
    }
  };

  const updateFournisseur = async () => {
    if (!selectedId) return;
    try {
      await axios.put(`${API_URL}/fournisseurs/${selectedId}`, {
        supplier: form.supplier,
        company: form.company,
        telephone: form.telephone,
        email: form.email,
        address: form.address,
        country: form.country,
        website: form.website,
        comment: form.comment,
      });

      // Handle cartes visites updates
      if (form.cartesVisites.length > 0) {
        await Promise.all(
          form.cartesVisites.map(async (carte) => {
            const formData = new FormData();
            formData.append("fournisseurId", selectedId.toString());
            formData.append("contact", carte.contact);
            formData.append("telephone", carte.telephone);
            formData.append("telephonePortable", carte.telephonePortable);
            formData.append("poste", carte.poste);
            formData.append("address", carte.address);
            formData.append("comment", carte.comment);
            formData.append("email", carte.email);
            formData.append("website", carte.website);
            if (carte.imageFaceFile)
              formData.append("imageFace", carte.imageFaceFile);
            if (carte.imageBackFile)
              formData.append("imageBack", carte.imageBackFile);

            if (carte.id) {
              await axios.put(
                `${API_URL}/cartes-visites/${carte.id}`,
                formData,
                {
                  headers: { "Content-Type": "multipart/form-data" },
                },
              );
            } else {
              await axios.post(`${API_URL}/cartes-visites`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
              });
            }
          }),
        );
      }

      toast.success("Fournisseur updated successfully! ✨");
      fetchFournisseurs();
    } catch (err) {
      console.error("Error updating fournisseur:", err);
      toast.error("Failed to update fournisseur.");
    }
  };

  const deleteFournisseur = async (id: number) => {
    try {
      await axios.delete(`${API_URL}/fournisseurs/${id}`);
      setFournisseurs((prev) => prev.filter((f) => f.id !== id));
      toast.info("Fournisseur deleted. 🗑️");
    } catch (err) {
      console.error("Error deleting fournisseur:", err);
      toast.error("Failed to delete fournisseur.");
    }
  };

  const deleteCarteVisite = async (carteId: number) => {
    try {
      await axios.delete(`${API_URL}/cartes-visites/${carteId}`);
      toast.success("Carte visite deleted!");
    } catch (err) {
      console.error("Error deleting carte visite:", err);
      toast.error("Failed to delete carte visite.");
    }
  };

  useEffect(() => {
    fetchFournisseurs();
  }, []);

  /* -------------------- VALIDATION -------------------- */
  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!form.supplier) newErrors.supplier = "Supplier name is required";
    if (!form.country) newErrors.country = "Country is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* -------------------- FILTERED FOURNISSEURS -------------------- */
  const filteredFournisseurs = fournisseurs.filter((fournisseur) => {
    const matchesSearch =
      fournisseur?.supplier?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      fournisseur?.company?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      fournisseur?.telephone?.includes(searchTerm) ||
      fournisseur?.email?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCountry =
      countryFilter === "all" || fournisseur.country === countryFilter;
    return matchesSearch && matchesCountry;
  });

  const paginatedFournisseurs = filteredFournisseurs.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  /* -------------------- CRUD MODAL -------------------- */
  const openModal = (type: "add" | "edit" | "view", id?: number) => {
    setModalType(type);
    setErrors({});
    setSelectedCountryCode("");
    if (type === "edit" && id) {
      const f = fournisseurs.find((f) => f.id === id);
      if (f) {
        setForm({
          supplier: f.supplier,
          company: f.company || "",
          telephone: f.telephone || "",
          email: f.email || "",
          address: f.address || "",
          country: f.country || "",
          website: f.website || "",
          comment: f.comment || "",
          cartesVisites: f.cartesVisites || [],
        });
        const countryData = countryList.find((c) => c.name === f.country);
        if (countryData) setSelectedCountryCode(countryData.code);
      }
      setSelectedId(id);
    } else if (type === "view" && id) {
      const f = fournisseurs.find((f) => f.id === id);
      if (f) {
        setForm({
          supplier: f.supplier,
          company: f.company || "",
          telephone: f.telephone || "",
          email: f.email || "",
          address: f.address || "",
          country: f.country || "",
          website: f.website || "",
          comment: f.comment || "",
          cartesVisites: f.cartesVisites || [],
        });
      }
    } else {
      setForm({
        supplier: "",
        company: "",
        telephone: "",
        email: "",
        address: "",
        country: "",
        website: "",
        comment: "",
        cartesVisites: [],
      });
    }
  };

  const closeModal = () => {
    setModalType(null);
    setSelectedCountryCode("");
  };

  const saveFournisseur = async () => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    if (modalType === "add") {
      await createFournisseur();
    } else if (modalType === "edit") {
      await updateFournisseur();
    }
    closeModal();
  };

  const addCarteVisite = () => {
    setForm({
      ...form,
      cartesVisites: [...form.cartesVisites, { ...emptyCarteVisite }],
    });
  };

  const removeCarteVisite = async (index: number) => {
    const carte = form.cartesVisites[index];
    if (carte.id) {
      await deleteCarteVisite(carte.id);
    }
    const newCartes = form.cartesVisites.filter((_, i) => i !== index);
    setForm({ ...form, cartesVisites: newCartes });
  };

  const updateCarteVisite = (
    index: number,
    field: keyof CarteVisite,
    value: any,
  ) => {
    const newCartes = [...form.cartesVisites];
    newCartes[index] = { ...newCartes[index], [field]: value };
    setForm({ ...form, cartesVisites: newCartes });
  };

  const clearFilters = () => {
    setSearchTerm("");
    setCountryFilter("all");
  };

  const exportToExcel = () => {
    try {
      const exportData = filteredFournisseurs.map((f) => ({
        Supplier: f.supplier,
        Company: f.company || "-",
        Telephone: f.telephone || "-",
        Email: f.email || "-",
        Address: f.address || "-",
        Country: f.country || "-",
        Website: f.website || "-",
        Comment: f.comment || "-",
        "Cartes Visites Count": f.cartesVisites?.length || 0,
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Fournisseurs");
      const fileName = `Fournisseurs_${new Date().toISOString().split("T")[0]}.xlsx`;
      XLSX.writeFile(workbook, fileName);
      toast.success("Excel file exported successfully! 📊");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toast.error("Failed to export to Excel.");
    }
  };

  const tableColumns = [
    { id: "name", label: "Name/Company", minWidth: 200 },
    { id: "contact", label: "Contact", minWidth: 200 },
    { id: "location", label: "Location", minWidth: 150 },
    { id: "cartesVisites", label: "Business Cards", minWidth: 120 },
    { id: "actions", label: "Actions", minWidth: 150, align: "right" as const },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <ToastContainer position="top-right" autoClose={5000} />

      <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={{ mb: 2 }}>
        <Link
          color="inherit"
          href="#"
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Home sx={{ mr: 0.5, fontSize: 20 }} />
          Home
        </Link>
        <Typography color="text.primary">Fournisseurs</Typography>
      </Breadcrumbs>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h4" fontWeight={700}>
          Fournisseurs Management
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => openModal("add")}
          sx={{
            bgcolor: "#C4B08C",
            color: "#000",
            "&:hover": { bgcolor: "#b39d77" },
            px: 3,
            py: 1,
            borderRadius: 2,
          }}
        >
          {isMobile ? "Add" : "Add Fournisseur"}
        </Button>
      </Box>

      <Paper
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <Box display="flex" flexDirection={isMobile ? "column" : "row"} gap={2}>
          <TextField
            fullWidth
            placeholder="Search fournisseurs..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm("")}>
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            size="small"
          />
          <Box display="flex" gap={1}>
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel>Country</InputLabel>
              <Select
                value={countryFilter}
                label="Country"
                onChange={(e) => setCountryFilter(e.target.value as string)}
              >
                <MenuItem value="all">
                  <em>All Countries</em>
                </MenuItem>
                {countryList.map((country) => (
                  <MenuItem key={country.code} value={country.name}>
                    {" "}
                    {/* Utiliser le nom comme valeur pour le filtre */}
                    <Box display="flex" alignItems="center" gap={1}>
                      <img
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png 2x`}
                        alt={`${country.name} flag`}
                      />
                      <Typography variant="body2">{country.name}</Typography>
                      {/* Optionnellement, afficher le code téléphonique */}
                      {/* {country.phoneCode && <Typography variant="caption" color="textSecondary" ml={1}>({country.phoneCode})</Typography>} */}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {(searchTerm || countryFilter !== "all") && (
              <Button onClick={clearFilters} startIcon={<Clear />} size="small">
                Clear
              </Button>
            )}
          </Box>
        </Box>
      </Paper>

      <Box display="flex" justifyContent="space-between" mb={2}>
        <Button
          variant="contained"
          startIcon={<FileDownload />}
          onClick={exportToExcel}
          sx={{
            bgcolor: "#C4B08C",
            color: "#000",
            "&:hover": { bgcolor: "#b39d77" },
          }}
        >
          Export to Excel
        </Button>
        <Box display="flex">
          <Button
            variant={viewMode === "table" ? "contained" : "outlined"}
            size="small"
            onClick={() => setViewMode("table")}
            sx={{
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              bgcolor: viewMode === "table" ? "#C4B08C" : undefined,
              color: viewMode === "table" ? "#000" : undefined,
            }}
          >
            Table
          </Button>
          <Button
            variant={viewMode === "grid" ? "contained" : "outlined"}
            size="small"
            onClick={() => setViewMode("grid")}
            sx={{
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              ml: "-1px",
              bgcolor: viewMode === "grid" ? "#C4B08C" : undefined,
              color: viewMode === "grid" ? "#000" : undefined,
            }}
          >
            Grid
          </Button>
        </Box>
      </Box>

      {viewMode === "table" && (
        <Paper
          sx={{
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,.08)",
            overflow: "hidden",
            mb: 3,
          }}
        >
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {tableColumns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        backgroundColor: "#f8f5f0",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        color="#555"
                      >
                        {column.label}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  Array.from(new Array(rowsPerPage)).map((_, index) => (
                    <TableRow key={index}>
                      {tableColumns.map((column) => (
                        <TableCell key={column.id}>
                          <Skeleton animation="wave" height={40} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : paginatedFournisseurs.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={tableColumns.length} align="center">
                      <Box py={5} textAlign="center">
                        <FilterList
                          sx={{ fontSize: 48, color: "text.secondary", mb: 2 }}
                        />
                        <Typography
                          variant="h6"
                          color="text.secondary"
                          gutterBottom
                        >
                          No fournisseurs found
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedFournisseurs.map((fournisseur) => (
                    <TableRow key={fournisseur.id} hover>
                      <TableCell>
                        <Box>
                          <Typography variant="body1" fontWeight={500}>
                            {fournisseur.supplier}
                          </Typography>
                          {fournisseur.company && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {fournisseur.company}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" flexDirection="column" gap={0.5}>
                          {fournisseur.telephone && (
                            <Box display="flex" alignItems="center">
                              <Phone
                                sx={{
                                  fontSize: 16,
                                  color: "text.secondary",
                                  mr: 1,
                                }}
                              />
                              <Typography variant="body2">
                                {fournisseur.telephone}
                              </Typography>
                            </Box>
                          )}
                          {fournisseur.email && (
                            <Box display="flex" alignItems="center">
                              <Email
                                sx={{
                                  fontSize: 16,
                                  color: "text.secondary",
                                  mr: 1,
                                }}
                              />
                              <Typography variant="body2">
                                {fournisseur.email}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" flexDirection="column" gap={0.5}>
                          {fournisseur.country && (
                            <Chip label={fournisseur.country} size="small" />
                          )}
                          {fournisseur.address && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {fournisseur.address}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={fournisseur.cartesVisites?.length || 0}
                          size="small"
                          sx={{
                            bgcolor: "rgba(196,176,140,0.1)",
                            color: "#C4B08C",
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Box display="flex" justifyContent="flex-end" gap={0.5}>
                          <Tooltip title="View">
                            <IconButton
                              onClick={() => openModal("view", fournisseur.id)}
                              sx={{ color: "#C4B08C" }}
                              size="small"
                            >
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <IconButton
                              onClick={() => openModal("edit", fournisseur.id)}
                              sx={{ color: "#111" }}
                              size="small"
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton
                              onClick={() => {
                                setFournisseurToDelete(fournisseur);
                                setIsDeleteDialogOpen(true);
                              }}
                              sx={{ color: "#d32f2f" }}
                              size="small"
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredFournisseurs.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}

      {viewMode === "grid" && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
          {filteredFournisseurs.map((fournisseur) => (
            <Card
              key={fournisseur.id}
              sx={{
                flex: "1 1 200px",
                minWidth: { xs: "100%", sm: "48%", md: "31%", lg: "23%" },
                borderRadius: 2,
                boxShadow: "0 4px 12px rgba(0,0,0,.08)",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(0,0,0,.12)",
                },
              }}
            >
              <CardContent sx={{ textAlign: "center", pb: 1 }}>
                <Avatar
                  sx={{
                    width: 60,
                    height: 60,
                    mx: "auto",
                    mb: 2,
                    bgcolor: "rgba(196,176,140,0.2)",
                    color: "#C4B08C",
                  }}
                >
                  {fournisseur.supplier.charAt(0)}
                </Avatar>
                <Typography variant="h6" gutterBottom>
                  {fournisseur.supplier}
                </Typography>
                {fournisseur.company && (
                  <Typography variant="body2" color="text.secondary">
                    {fournisseur.company}
                  </Typography>
                )}
                <Chip
                  label={`${fournisseur.cartesVisites?.length || 0} cards`}
                  size="small"
                  sx={{ mt: 1 }}
                />
              </CardContent>
              <Divider />
              <CardActions sx={{ justifyContent: "center", py: 1 }}>
                <IconButton
                  onClick={() => openModal("view", fournisseur.id)}
                  sx={{ color: "#C4B08C" }}
                >
                  <Visibility />
                </IconButton>
                <IconButton
                  onClick={() => openModal("edit", fournisseur.id)}
                  sx={{ color: "#111" }}
                >
                  <Edit />
                </IconButton>
                <IconButton
                  onClick={() => {
                    setFournisseurToDelete(fournisseur);
                    setIsDeleteDialogOpen(true);
                  }}
                  sx={{ color: "#d32f2f" }}
                >
                  <Delete />
                </IconButton>
              </CardActions>
            </Card>
          ))}
        </Box>
      )}

      {/* MODAL */}
      {modalType && (
        <Dialog
          open
          onClose={closeModal}
          fullWidth
          maxWidth="md"
          fullScreen={isMobile}
        >
          <DialogTitle
            sx={{
              fontSize: "1.5rem",
              fontWeight: 600,
              bgcolor: "#f8f5f0",
              py: 2,
            }}
          >
            {modalType === "add"
              ? "Add New Fournisseur"
              : modalType === "edit"
                ? "Edit Fournisseur"
                : "Fournisseur Details"}
            <IconButton
              onClick={closeModal}
              size="small"
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <Clear />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ py: 3 }}>
            {modalType === "view" ? (
              <Box>
                <Typography>
                  <strong>Supplier:</strong> {form.supplier}
                </Typography>
                <Typography>
                  <strong>Company:</strong> {form.company || "-"}
                </Typography>
                <Typography>
                  <strong>Telephone:</strong> {form.telephone || "-"}
                </Typography>
                <Typography>
                  <strong>Email:</strong> {form.email || "-"}
                </Typography>
                <Typography>
                  <strong>Country:</strong> {form.country || "-"}
                </Typography>
                <Typography>
                  <strong>Address:</strong> {form.address || "-"}
                </Typography>
                <Typography>
                  <strong>Website:</strong> {form.website || "-"}
                </Typography>
                <Typography>
                  <strong>Comment:</strong> {form.comment || "-"}
                </Typography>

                <Divider sx={{ my: 2 }} />
                <Typography variant="h6" gutterBottom>
                  Business Cards ({form.cartesVisites.length})
                </Typography>
                {form.cartesVisites.map((carte, index) => (
                  <Box
                    key={index}
                    sx={{ mb: 3, p: 2, bgcolor: "#f8f5f0", borderRadius: 2 }}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      gutterBottom
                    >
                      <ContactMail
                        sx={{ fontSize: 18, mr: 1, verticalAlign: "middle" }}
                      />
                      {carte.contact}
                    </Typography>

                    <Box display="flex" flexDirection="column" gap={1} mb={2}>
                      {carte.poste && (
                        <Typography variant="body2">
                          <strong>Position:</strong> {carte.poste}
                        </Typography>
                      )}
                      {carte.email && (
                        <Typography variant="body2">
                          <strong>Email:</strong> {carte.email}
                        </Typography>
                      )}
                      {carte.telephone && (
                        <Typography variant="body2">
                          <strong>Phone:</strong> {carte.telephone}
                        </Typography>
                      )}
                      {carte.telephonePortable && (
                        <Typography variant="body2">
                          <strong>Mobile:</strong> {carte.telephonePortable}
                        </Typography>
                      )}
                      {carte.website && (
                        <Typography variant="body2">
                          <strong>Website:</strong> {carte.website}
                        </Typography>
                      )}
                      {carte.address && (
                        <Typography variant="body2">
                          <strong>Address:</strong> {carte.address}
                        </Typography>
                      )}
                      {carte.comment && (
                        <Typography variant="body2">
                          <strong>Comment:</strong> {carte.comment}
                        </Typography>
                      )}
                    </Box>

                    {/* Business Card Images */}
                    {(carte.imageFace || carte.imageBack) && (
                      <Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography
                          variant="subtitle2"
                          fontWeight={600}
                          gutterBottom
                        >
                          Business Card Images
                        </Typography>
                        <Box
                          display="flex"
                          gap={2}
                          flexWrap="wrap"
                          sx={{ mt: 1 }}
                        >
                          {carte.imageFace && (
                            <Box flex="1" minWidth="250px">
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                display="block"
                                mb={1}
                              >
                                Front Side
                              </Typography>
                              <Box
                                component="img"
                                src={`${IMAGE_URL}/cartes-visites/${carte.imageFace}`}
                                alt="Business Card Front"
                                sx={{
                                  width: "100%",
                                  maxWidth: "400px",
                                  height: "auto",
                                  borderRadius: 1,
                                  border: "1px solid #ddd",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                  cursor: "pointer",
                                  transition: "transform 0.2s",
                                  "&:hover": {
                                    transform: "scale(1.05)",
                                  },
                                }}
                                onClick={() =>
                                  window.open(
                                    `${IMAGE_URL}/cartes-visites/${carte.imageFace}`,
                                    "_blank",
                                  )
                                }
                              />
                            </Box>
                          )}
                          {carte.imageBack && (
                            <Box flex="1" minWidth="250px">
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                display="block"
                                mb={1}
                              >
                                Back Side
                              </Typography>
                              <Box
                                component="img"
                                src={`${IMAGE_URL}/cartes-visites/${carte.imageBack}`}
                                alt="Business Card Back"
                                sx={{
                                  width: "100%",
                                  maxWidth: "400px",
                                  height: "auto",
                                  borderRadius: 1,
                                  border: "1px solid #ddd",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                  cursor: "pointer",
                                  transition: "transform 0.2s",
                                  "&:hover": {
                                    transform: "scale(1.05)",
                                  },
                                }}
                                onClick={() =>
                                  window.open(
                                    `${IMAGE_URL}/cartes-visites/${carte.imageBack}`,
                                    "_blank",
                                  )
                                }
                              />
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            ) : (
              <Box display="flex" flexDirection="column" gap={2}>
                <Typography variant="h6">Fournisseur Information</Typography>
                <Box display="flex" flexWrap="wrap" gap={2}>
                  <TextField
                    label="Supplier Name"
                    value={form.supplier}
                    onChange={(e) =>
                      setForm({ ...form, supplier: e.target.value })
                    }
                    error={!!errors.supplier}
                    helperText={errors.supplier}
                    required
                    size="small"
                    sx={{ flex: "1 1 48%" }}
                  />
                  <TextField
                    label="Company"
                    value={form.company}
                    onChange={(e) =>
                      setForm({ ...form, company: e.target.value })
                    }
                    size="small"
                    sx={{ flex: "1 1 48%" }}
                  />
                  <TextField
                    label="Telephone"
                    value={form.telephone}
                    onChange={(e) =>
                      setForm({ ...form, telephone: e.target.value })
                    }
                    size="small"
                    sx={{ flex: "1 1 48%" }}
                  />
                  <TextField
                    label="Email"
                    value={form.email}
                    onChange={(e) =>
                      setForm({ ...form, email: e.target.value })
                    }
                    type="email"
                    size="small"
                    sx={{ flex: "1 1 48%" }}
                  />
                  <FormControl
                    size="small"
                    sx={{ flex: "1 1 48%" }}
                    required
                    error={!!errors.country}
                  >
                    <InputLabel>Country</InputLabel>
                    <Select
                      value={selectedCountryCode}
                      label="Country"
                      onChange={(e) => {
                        const code = e.target.value as string;
                        setSelectedCountryCode(code);
                        const country = countryList.find(
                          (c) => c.code === code,
                        );
                        setForm({ ...form, country: country?.name || "" });
                      }}
                    >
                      <MenuItem value="all">
                        <em>All Countries</em>
                      </MenuItem>
                      {countryList.map((country) => (
                        <MenuItem key={country.code} value={country.code}>
                          {" "}
                          {/* Utiliser le nom comme valeur pour le filtre */}
                          <Box display="flex" alignItems="center" gap={1}>
                            <img
                              loading="lazy"
                              width="20"
                              src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
                              srcSet={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png 2x`}
                              alt={`${country.name} flag`}
                            />
                            <Typography variant="body2">
                              {country.name}
                            </Typography>
                            {/* Optionnellement, afficher le code téléphonique */}
                            {/* {country.phoneCode && <Typography variant="caption" color="textSecondary" ml={1}>({country.phoneCode})</Typography>} */}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Address"
                    value={form.address}
                    onChange={(e) =>
                      setForm({ ...form, address: e.target.value })
                    }
                    size="small"
                    sx={{ flex: "1 1 48%" }}
                  />
                  <TextField
                    label="Website"
                    value={form.website}
                    onChange={(e) =>
                      setForm({ ...form, website: e.target.value })
                    }
                    size="small"
                    fullWidth
                  />
                  <TextField
                    label="Comment"
                    value={form.comment}
                    onChange={(e) =>
                      setForm({ ...form, comment: e.target.value })
                    }
                    size="small"
                    multiline
                    rows={2}
                    fullWidth
                  />
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h6">Business Cards</Typography>
                  <Button
                    variant="outlined"
                    startIcon={<Add />}
                    onClick={addCarteVisite}
                    size="small"
                    sx={{ color: "#C4B08C", borderColor: "#C4B08C" }}
                  >
                    Add Card
                  </Button>
                </Box>

                {form.cartesVisites.map((carte, index) => (
                  <Accordion key={index}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography>
                        {carte.contact || `Business Card ${index + 1}`}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box display="flex" flexDirection="column" gap={2}>
                        <TextField
                          label="Contact Name"
                          value={carte.contact}
                          onChange={(e) =>
                            updateCarteVisite(index, "contact", e.target.value)
                          }
                          size="small"
                          required
                          fullWidth
                        />
                        <Box display="flex" gap={2}>
                          <TextField
                            label="Telephone"
                            value={carte.telephone}
                            onChange={(e) =>
                              updateCarteVisite(
                                index,
                                "telephone",
                                e.target.value,
                              )
                            }
                            size="small"
                            fullWidth
                          />
                          <TextField
                            label="Mobile"
                            value={carte.telephonePortable}
                            onChange={(e) =>
                              updateCarteVisite(
                                index,
                                "telephonePortable",
                                e.target.value,
                              )
                            }
                            size="small"
                            fullWidth
                          />
                        </Box>
                        <TextField
                          label="Position"
                          value={carte.poste}
                          onChange={(e) =>
                            updateCarteVisite(index, "poste", e.target.value)
                          }
                          size="small"
                          fullWidth
                        />
                        <TextField
                          label="Email"
                          value={carte.email}
                          onChange={(e) =>
                            updateCarteVisite(index, "email", e.target.value)
                          }
                          type="email"
                          size="small"
                          fullWidth
                        />
                        <TextField
                          label="Website"
                          value={carte.website}
                          onChange={(e) =>
                            updateCarteVisite(index, "website", e.target.value)
                          }
                          size="small"
                          fullWidth
                        />
                        <TextField
                          label="Address"
                          value={carte.address}
                          onChange={(e) =>
                            updateCarteVisite(index, "address", e.target.value)
                          }
                          size="small"
                          fullWidth
                        />
                        <TextField
                          label="Comment"
                          value={carte.comment}
                          onChange={(e) =>
                            updateCarteVisite(index, "comment", e.target.value)
                          }
                          size="small"
                          multiline
                          rows={2}
                          fullWidth
                        />

                        <Box display="flex" gap={2}>
                          <Box flex={1}>
                            <Typography variant="caption">
                              Front Image
                            </Typography>
                            <Button
                              variant="outlined"
                              component="label"
                              size="small"
                              fullWidth
                              startIcon={<CloudUpload />}
                            >
                              Upload Front
                              <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  if (file)
                                    updateCarteVisite(
                                      index,
                                      "imageFaceFile",
                                      file,
                                    );
                                }}
                              />
                            </Button>
                            {carte.imageFaceFile && (
                              <Typography
                                variant="caption"
                                color="success.main"
                              >
                                ✓ File selected
                              </Typography>
                            )}
                          </Box>
                          <Box flex={1}>
                            <Typography variant="caption">
                              Back Image
                            </Typography>
                            <Button
                              variant="outlined"
                              component="label"
                              size="small"
                              fullWidth
                              startIcon={<CloudUpload />}
                            >
                              Upload Back
                              <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  if (file)
                                    updateCarteVisite(
                                      index,
                                      "imageBackFile",
                                      file,
                                    );
                                }}
                              />
                            </Button>
                            {carte.imageBackFile && (
                              <Typography
                                variant="caption"
                                color="success.main"
                              >
                                ✓ File selected
                              </Typography>
                            )}
                          </Box>
                        </Box>

                        <Button
                          variant="outlined"
                          color="error"
                          startIcon={<Delete />}
                          onClick={() => removeCarteVisite(index)}
                          size="small"
                        >
                          Remove Card
                        </Button>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={closeModal}>Cancel</Button>
            {modalType !== "view" && (
              <Button
                variant="contained"
                onClick={saveFournisseur}
                sx={{
                  bgcolor: "#C4B08C",
                  color: "#000",
                  "&:hover": { bgcolor: "#b39d77" },
                }}
              >
                Save
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}

      {/* DELETE DIALOG */}
      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete {fournisseurToDelete?.supplier}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteDialogOpen(false)}>Cancel</Button>
          <Button
            color="error"
            onClick={() => {
              if (fournisseurToDelete) {
                deleteFournisseur(fournisseurToDelete.id);
                setIsDeleteDialogOpen(false);
                setFournisseurToDelete(null);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default FournisseurPage;
